export default "__VITE_ASSET__DFdfb88y__"